function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgHeadset(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M79.879 40.656C78.605 22.641 66.895 12 48 12c-22.925 0-30.573 17.169-31.811 28.631C11.437 42.229 8 46.716 8 52v16c0 6.617 5.383 12 12 12s12-5.383 12-12V52c0-5.099-3.202-9.453-7.696-11.188.361-2.409 1.152-5.861 2.887-9.247C31.124 23.891 38.125 20 48 20c17.9 0 23.036 10.628 23.869 20.748C67.284 42.437 64 46.837 64 52v16c0 6.617 5.383 12 12 12s12-5.383 12-12V52c0-5.258-3.404-9.727-8.121-11.344zM24 68c0 2.206-1.794 4-4 4s-4-1.794-4-4V52c0-2.206 1.794-4 4-4s4 1.794 4 4v16zm56 0c0 2.206-1.794 4-4 4s-4-1.794-4-4V52c0-2.206 1.794-4 4-4s4 1.794 4 4v16z"
  }));
}

SvgHeadset.clsName = 'icon-www__headset';
SvgHeadset.remarkName = 'unknown';
export default SvgHeadset;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Headset.js
// module id = 2356
// module chunks = 17 18